import { map, get, keyBy, reduce } from 'lodash'
const defaultColumn = () => (
  { title: 'empty', render: () => (null) }
)

/**
 *
 * @param {*} columns
 *
 * columns: [{
 *    key: 'columnsX'
 *    columnSet: [
 *      {index: 1, render: () => (test)},
 *      {index: 2, render: () => (test)}
 *    ],
 *    scheme: [1,0,0,0,0,2,0]
 * }]
 *
 */
export const generateColumns = (columns) => {
  const columnsSet = reduce(columns, (acc, { key, columnSet, scheme }) => {
    const columnScheme = map(scheme, (columnIndex) => {
      return get(keyBy(columnSet, 'index'), columnIndex, defaultColumn())
    })
    return { ...acc, [key]: columnScheme }
  }, {})
  return columnsSet
}
